import { render } from "./SgdeToAed.vue?vue&type=template&id=2a48fe72&scoped=true"
import script from "./SgdeToAed.vue?vue&type=script&lang=js"
export * from "./SgdeToAed.vue?vue&type=script&lang=js"

import "./SgdeToAed.vue?vue&type=style&index=0&id=2a48fe72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a48fe72"]])

export default __exports__